<router-outlet></router-outlet>
<p-confirmDialog [style]="{'min-width': '30vw'}" [styleClass]="options?.className"></p-confirmDialog>
<p-confirmpopup key="confirmPopUp" ></p-confirmpopup>